import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import ListIcon from '@material-ui/icons/List';
import DetailIcon from '@material-ui/icons/Subject';
import MapOutlinedIcon from '@material-ui/icons/MapOutlined';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';

const styles = theme => ({
  actionWrapper: {
    alignItems: 'center',
    display: 'flex',
    flex: 1,
    marginLeft: theme.spacing.unit * 5
  },
  verticalDivider: {
    width: 1,
    height: '21px',
    backgroundColor: '#000000',
    marginLeft: 17,
    marginRight: 17,
    opacity: 0.12
  },
  iconContainer: {
    alignItems: 'center',
    display: 'flex'
  },
  contentOptions: {
    alignItems: 'center',
    display: 'flex',
    height: 24
  }
});

export class ViewToggle extends PureComponent {
  static propTypes = {
    onPrimaryClick: PropTypes.func.isRequired,
    onSecondaryClick: PropTypes.func.isRequired,
    detailIcon: PropTypes.oneOf(['list', 'detail']),
    primarySelected: PropTypes.bool.isRequired
  };

  render() {
    const {
      classes,
      onPrimaryClick,
      onSecondaryClick,
      primarySelected,
      detailIcon
    } = this.props;
    return (
      <div className={classes.actionWrapper}>
        <div aria-label="list-view" className={classes.iconContainer}>
          <IconButton
            onClick={onPrimaryClick}
            classes={{
              root: classes.buttonsRoot
            }}
            color={primarySelected ? 'primary' : 'default'}
          >
            {detailIcon === 'list' ? (
              <ListIcon className={classnames(classes.contentOption)} />
            ) : (
              <DetailIcon className={classnames(classes.contentOption)} />
            )}
          </IconButton>
        </div>
        <div className={classes.verticalDivider} />
        <div aria-label="map-view" className={classes.iconContainer}>
          <IconButton
            onClick={onSecondaryClick}
            classes={{
              root: classes.buttonsRoot
            }}
            color={!primarySelected ? 'primary' : 'default'}
          >
            <MapOutlinedIcon className={classnames(classes.contentOption)} />
          </IconButton>
        </div>
      </div>
    );
  }
}
export default withStyles(styles)(ViewToggle);
